import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from './../spzaComponent';
class DriveModal extends SpzaComponent {
    renderImpl() {
        let sourceUrl = this.props.drive.urlLink;
        return /*#__PURE__*/ _jsx("div", {
            role: "dialog",
            "aria-label": "test drive is now open",
            className: "driveModalClass",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "dialogContent",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "toolBar",
                        children: /*#__PURE__*/ _jsx("button", {
                            id: "cancelButton",
                            "aria-label": "close",
                            className: "cancel",
                            onClick: this.props.dismissModal,
                            children: /*#__PURE__*/ _jsx("span", {
                                className: "c-glyph"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "driveContainer",
                        children: /*#__PURE__*/ _jsx("iframe", {
                            frameBorder: "0",
                            width: "1200",
                            height: "675",
                            src: sourceUrl
                        })
                    })
                ]
            })
        });
    }
}
export { DriveModal as default };
DriveModal.contextTypes = {
    loc: PropTypes.func,
    renderErrorModal: PropTypes.func
};
